import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SharedStore } from '@shared/store/shared.signal-store';
import { AuthStore } from './store/auth.signal-store';

export const twoFactorAuthResolver: ResolveFn<void> = () => {
  const sharedStore = inject(SharedStore);
  const authStore = inject(AuthStore);

  if (!sharedStore.is2FAEnabled()) {
    authStore.load2FALink();
  }
};
